import React, { Fragment, useContext, useEffect, useState } from 'react'
import { AiFillHome } from "@react-icons/all-files/ai/AiFillHome";
import { BsCalendar } from "@react-icons/all-files/bs/BsCalendar";
//cita_single

import { MdFamilyRestroom, MdTipsAndUpdates, MdOutlineArrowBack, MdKeyboardArrowRight } from 'react-icons/md';
import { IoDocumentTextOutline, IoIosDocument, IoMdArrowDropdown } from 'react-icons/io';
import { CgProfile, CgLogOut, CgHashtag } from 'react-icons/cg';
import { AiOutlinePlusCircle, AiFillFolder, AiFillFile, AiFillCheckCircle, AiOutlinePlus, AiOutlineCloseCircle, AiOutlineTags } from 'react-icons/ai'
import { FiCornerRightDown } from 'react-icons/fi'
import { AiFillCloseCircle } from 'react-icons/ai'
import { BsFillPersonFill, BsClock } from 'react-icons/bs'
import Renderif from '../../components/renderif';
import SideMenu, { AdminSideMenu } from '../../components/sidemenu';
import CheckBox from '../../components/checkbox';
import DropDown, { DropDownOption } from '../../components/dropdown';
import BVCalendar from '../../components/calendar';
import TipCard from '../../components/tipcard';
import { useNavigate, useParams } from 'react-router-dom';
import { Service } from '../../services/api';
import Loader from '../../components/loader';
import { AuthContext } from '../../context/auth_context';
import { primary } from '../../utils/colors';

import { AlertContext } from '../../context/alert_context';

import AgregarTip from '../psicologo/agregar_tip_psico';
import AgregarDocumento from '../psicologo/agregar_documento_psico';






export default function CitaSingleAdmin() {

    const navigate = useNavigate();

    const { user } = useContext(AuthContext)
    const { notify } = useContext(AlertContext)

    const [state, setState] = useState({
        tab: 0,
        show_cliente_detail_id: null,
        tags: [],
        tag: '',
        agreement: '',
        cita: null,
        loading: false,
        show_add: '',
        require_update: false,
        sessionRecord: '',
        generalInformation: '',
        show_family_modal: false,
        family_members: []

    })

    const { cita_id } = useParams()


    useEffect(() => {

        // const init = async () => {
        //     setState({...state, loading:true})
        //     let cita = await Service('GET', `Appointment/${cita_id}`)
        //     let tags = await Service('GET', `Tag?pageNumber=1&pageSize=999`);
        //     console.log(tags)
        //     setState({
        //         ...state, 
        //         cita:cita.data, 
        //         loading:false, 
        //         tags:tags.data.data,
        //         sessionRecord:cita.data?.sessionRecord,
        //         generalInformation:cita.data?.generalInformation

        //     })
        //     console.log(cita);

        // }
        init();

        return () => { }
    }, [cita_id])

    const init = async () => {
        setState({ ...state, loading: true })
        let cita = await Service('GET', `Appointment/${cita_id}`)
        let tags = await Service('GET', `Tag?pageNumber=1&pageSize=999`);
        console.log(cita)
        setState({
            ...state,
            cita: cita.data,
            loading: false,
            tags: tags.data.data,
            sessionRecord: cita.data?.sessionRecord,
            generalInformation: cita.data?.generalInformation

        })
        console.log(cita);
    }



    const onAddAgreement = async () => {
        state.cita.agreements.push({
            id: null,
            agreementTitle: state.agreement,
            patth: null
        });
        setState({ ...state, agreement: '' })
        let body = {
            appointmentId: cita_id,
            agreementTitle: state.agreement

        }
        let add_agreement = await Service('POST', `Agreement`, body);
        console.log(add_agreement)
        if (add_agreement.status === 200) {
            notify({ title: 'Agregar Acuerdo', message: '¡Listo! Se agrego nuevo Acuerdo', type: 'success' })
        } else {
            notify({ title: 'Agregar Acuerdo', message: 'Error!  Algo salio mal, intenta de nuevo más tarde.', type: 'error' })
        }

    }

    const selectFamily = async () => {
        setState({ ...state, show_family_modal: true })
    }
    const onRemoveAgreement = async ({ agreement }) => {

        state.cita.agreements = state.cita.agreements.filter((item) => item !== agreement)
        setState({ ...state, agreement: '' })


        let body = {
            "idAgreement": agreement.id,
            "idAppointment": cita_id

        }
        console.log(body)
        let remove_agreement = await Service('DELETE', `Agreement/remove`, JSON.stringify(body));
        console.log(remove_agreement)
        // if(add_agreement.status === 200){
        //     notify({title:'Agregar Acuerdo', message:'¡Listo! Se agrego nuevo Acuerdo', type:'success'})
        // }else{
        //     notify({title:'Agregar Acuerdo', message:'Error!  Algo salio mal, intenta de nuevo más tarde.', type:'error'})
        // }

    }
    const onCreateTag = async () => {
        if (state.tag === '') {
            return;
        }

        state.cita.patient.tag.push({
            id: null,
            name: state.tag
        })

        let body = {
            name: state.tag
        }
        let add_tag = await Service('POST', 'Tag', body);
        console.log(add_tag)
        if (add_tag.status === 201) {
            notify({ title: 'Agregar Etiqueta', message: '¡Listo!', type: 'success' })
        } else {
            notify({ title: 'Agregar Etiqueta', message: 'Error!  Algo salio mal, intenta de nuevo más tarde.', type: 'error' })
        }
        setState({ ...state, tag: '' })


    }
    const onAddTag = async ({ tag }) => {

        console.log(tag)

        if (state.cita.patient.tag == null) {
            state.cita.patient.tag = []
            state.cita.patient.tag.push(tag)
        } else {
            state.cita.patient.tag.push(tag)
        }
        setState({ ...state, tag: '' })
        let body = {
            id: tag.id,
            relation: state.cita.patient.id,
            type: 2

        }
        let add_tag = await Service('POST', `Tag/addTag`, body);
        console.log(add_tag)
        if (add_tag.status === 200) {
            notify({ title: 'Agregar Etiqueta', message: '¡Listo! Se agrego nuevo Etiqueta', type: 'success' })
        } else {
            notify({ title: 'Agregar Etiqueta', message: 'Error!  Algo salio mal, intenta de nuevo más tarde.', type: 'error' })
        }

    }

    const onRemoveTag = async ({ tag }) => {
        state.cita.patient.tag = state.cita.patient.tag.filter((item) => item !== tag)
        setState({ ...state })

        let body = {
            id: tag.id,
            relation: state.cita.patient.id,
            type: 2

        }
        console.log(body)

        let remove_tag = await Service('DELETE', `Tag/removeTag`, body);
        console.log(remove_tag)
        // if(remove_tag.status === 204){
        //     notify({title:'Eliminar Etiqueta', message:'¡Listo! Se elimina la Etiqueta', type:'success'})
        // }else{
        //     notify({title:'Eliminar Etiqueta', message:'Error!  Algo salio mal, intenta de nuevo más tarde.', type:'error'})
        // }
    }

    const onFilterTags = () => {


        return state.tags.filter((tag) => {

            if (state.tag.length < 3) {
                return false;
            }

            if (tag.name.toUpperCase().includes(state.tag.toUpperCase())) {
                return true
            }
            return false



        })
    }

    const update = async () => {
        let body = {
            id: cita_id,
            sessionRecord: state.sessionRecord,
            generalInformation: state.generalInformation
        }

        let update = await Service('PATCH', 'Appointment', body);
        if (update.status === 200) {
            notify({ title: 'Guardar Cambios', message: '¡Listo! Se guardaron los cambios', type: 'success' })
        } else {
            notify({ title: 'Guardar Cambios', message: 'Error!  Algo salio mal, intenta de nuevo más tarde.', type: 'error' })
        }
        setState({ ...state, require_update: false })


    }

    const onDeleteTip = async (tip) => {
        let body = {
            "tipId": tip.id,
            "appointmentId": cita_id

        }
        let _delete = await Service('DELETE', `Tip/remove`, JSON.stringify(body));
        if (_delete.status === 200) {

            init();
        }
    }





    return (
        <>

            <Renderif isTrue={state.show_family_modal}>
                <div className='overlay d-flex justify-content-center align-items-center'>
                    <div className='bv-modal shadow'>
                        <div className='px-4 pt-3 pb-4 d-flex align-items-center'>
                            <div className='f-16 text-gray'>Selecciona al menos un familiar</div>
                            <div className='col'></div>
                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {

                                setState({ ...state, show_family_modal: false })

                            }}> <AiFillCloseCircle size={24} color="#30B7E7"></AiFillCloseCircle></div>
                        </div>
                        <div className='px-4 pb-5'>
                            <div>
                                <input type="checkbox" value="C"  />
                                <label className="f-14 text-black" >Padre</label>
                            </div>
                            <div>
                                <input type="checkbox" value="C"  />
                                <label className="f-14 text-black" >Made</label>
                            </div>
                            <div>
                                <input type="checkbox" value="C"  />
                                <label className="f-14 text-black" >Hijo</label>
                            </div>
                        </div>
                        <div className='d-flex b-top p-4'>
                            <div className='col'></div>
                            <div className='bv-pill bv-pill--gray me-2 cursor-pointer' onClick={() => {
                                setState({ ...state, show_family_modal: false })
                            }}>Cancelar</div>
                            <div className='bv-pill bv-pill--primary cursor-pointer' onClick={async () => {


                            }}>Continuar</div>
                        </div>
                    </div>
                </div>
            </Renderif>

            <Renderif isTrue={state.loading}>
                <Loader></Loader>
            </Renderif>
            <Renderif isTrue={state.show_add === 'agregar-tip'}>
                <AgregarTip onCancel={() => {
                    state.show_add = ''
                    init();
                    // setState({...state, show_add:''})

                }}></AgregarTip>
            </Renderif>

            <Renderif isTrue={state.show_add === 'agregar-doc'}>
                <AgregarDocumento step={1} onCancel={() => {

                    // setState({...state, show_add:''})
                    state.show_add = ''
                    init();
                }}></AgregarDocumento>
            </Renderif>


            <div className='container-fluid h-100 d-flex'>


                <AdminSideMenu></AdminSideMenu>



                <div className='col hide-scroll'>

                    <div className='row m-0'>

                        <div className='col-12 col-xl-8 p-0 vh-xl-100-overflowed hide-scroll'>

                            {/* <div className='d-inline-flex d-sm-none align-items-center px-1 px-lg-3 pb-1 pb-lg-2 highlight-text-hover cursor-pointer'>
                        <div className='bv-icon bv-icon--mid'><MdOutlineArrowBack size={20} color={'#777777'}></MdOutlineArrowBack></div>
                        <div className='text-gray f-14 line-0'>Regresar</div>
                    </div> */}


                            <div className='d-none d-sm-flex p-1 pt-3  p-lg-3'>
                                <div className='avatar avatar--mid'></div>
                                <div className='ms-2'>

                                    <div className='f-16 bold '>¡Hola! {user.firstName} {user.lastName}.</div>
                                    <div className='f-14 text-gray line-0'>{user.email}</div>
                                </div>
                                <div className='col'></div>
                                <div className='d-flex flex-column align-items-end'>

                                    <div className='text-red f-12 bold pe-2'>
                                        {/* 00:37 */}
                                    </div>

                                    <div className='d-flex justify-content-end align-items-center'>
                                        {/* <div className='text-gray f-12 p-2'>5:25 PM</div> */}
                                        <div className='bv-pill bv-pill--primary cursor-pointer' onClick={() => {
                                            window.open(state.cita?.sessionUrl, '_blank')
                                        }}>Videollamada</div>
                                    </div>
                                </div>
                            </div>

                            <div className='d-flex d-sm-none flex-column p-2'>

                                <div className='d-flex'>
                                    <div className='avatar avatar--mid'></div>
                                    <div className='ms-2'>

                                        <div className='f-16 bold '>¡Hola! {user.firstName} {user.lastName}.</div>
                                        <div className='f-14 text-gray line-0'>{user.email}</div>
                                    </div>
                                </div>

                                <div className='d-flex flex-column align-items-end'>

                                    <div className='text-red f-12 bold pe-2'>
                                        {/* 00:37 */}
                                    </div>

                                    <div className='d-flex justify-content-end align-items-center'>
                                        <div className='text-gray f-12 p-2'>5:25 PM</div>
                                        <div className='bv-pill bv-pill--primary'>Videollamada</div>
                                    </div>
                                </div>
                            </div>


                            <div className='d-inline-flex align-items-center px-1 px-lg-3 pb-1 pb-lg-2 highlight-text-hover cursor-pointer' onClick={() => {
                                navigate(-1)
                            }}>

                                <div className='bv-icon bv-icon--mid'><MdOutlineArrowBack size={20} color={'#777777'}></MdOutlineArrowBack></div>
                                <div className='text-gray f-14 line-0'>Regresar</div>

                            </div>


                            {/* 
                    <div className='w-100 d-flex px-1 px-lg-3'>
                        <div className='pe-1'><input type="date" className='input--light'></input></div>
                        <div className='col'><input type='text' placeholder='Buscar paciente' className='input--light'></input></div>
                    </div> */}





                            <div className='px-1 px-lg-3 '>

                                <div className='d-block d-md-none'>
                                    <ClienteItem></ClienteItem>
                                </div>



                                <div className='bv-table d-none d-md-block'>
                                    <table className='w-100'>
                                        <thead>
                                            <tr>
                                                <td>
                                                    <div className='d-flex align-items-center'>


                                                        <div className='bv-icon'><BsFillPersonFill size={12} color="#777777" /></div>
                                                        <div className='text-gray line-0 f-12 bold'>Nombre</div>
                                                    </div>
                                                </td>
                                                {/* <td>
                                                <div className='d-flex align-items-center'>
                                                   
                                                    <div className='text-gray f-12 bold line-0'>Edad</div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='d-flex align-items-center'>
                                               
                                                    <div className='text-gray f-12 bold line-0'>Sexo</div>
                                                </div>
                                            </td> */}
                                                <td>
                                                    <div className='d-flex align-items-center'>
                                                        <div className='bv-icon'><BsCalendar size={12} color="#777777" /></div>
                                                        <div className='text-gray f-12 bold line-0'>Fecha</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='d-flex align-items-center justify-content-center'>
                                                        <div className='bv-icon'><CgHashtag size={14} color="#777777" /></div>
                                                        <div className='text-gray f-12 bold line-0'>Sesión</div>
                                                    </div>
                                                </td>


                                                <td>
                                                    <div className='d-flex align-items-center justify-content-center'>
                                                        <div className='bv-icon'><AiFillFolder size={16} color="#777777" /></div>
                                                        <div className='text-gray f-12 bold line-0'>Expediente</div>
                                                    </div>
                                                </td>




                                            </tr>
                                        </thead>
                                        <tbody>


                                            <>
                                                <tr>
                                                    <td>
                                                        <div>
                                                            <div className='text-gray f-12'>{state.cita?.patient.firstName} {state.cita?.patient.lastName}</div>
                                                            <div className='text-gray f-10'>{state.cita?.patient.email}</div>
                                                        </div>
                                                    </td>

                                                    {/* <td><div className='text-gray f-12'>32</div></td>
                                                    <td><div className='text-gray f-12'>M</div></td> */}
                                                    <td><div className='text-gray f-12'>{state.cita?.date}</div></td>
                                                    <td><div className='text-black bold f-12 text-center'>{state.cita?.numberOfSession}</div></td>

                                                    <td><div className='text-gray f-12 text-center'>#{state.cita?.patient.proceedings}</div></td>
                                                    {/* <td>
                                                        <div className={`bv-pill cursor-pointer ${state.show_cita_detail_id === i ? 'bv-pill--gray':'bv-pill--green'}`} onClick={()=>{
                                                            
                                                            setState({...state, show_cita_detail_id: state.show_cita_detail_id === i ? null : i})
                                                        }}>
                                                            {state.show_cita_detail_id === i ? 'Ocultar':'Ver seguimiento'}
                                                            
                                                        </div>
                                                    </td> */}


                                                </tr>
                                                {/* <Renderif isTrue={state.show_cita_detail_id === i}> */}
                                                <tr className='bg-light'>
                                                    <td colSpan={8}>
                                                        <ClienteDetail description={state.cita?.description}></ClienteDetail>
                                                    </td>
                                                </tr>
                                                {/* </Renderif> */}
                                            </>



                                        </tbody>

                                    </table>
                                    <div className='px-2 pt-2 pt-xl-3 px-xl-3'>
                                        <div>
                                            <div className='f-14 text-black'>Informacion General</div>
                                            <div className='f-12 text-gray'>Descripción del problema, Objetivo de intervención, Procedimiento, Resultados</div>
                                        </div>
                                        <textarea rows={4} value={state.generalInformation} onChange={(evt) => {

                                            setState({ ...state, generalInformation: evt.currentTarget.value, require_update: true })

                                        }} className='input--light py-1'></textarea>
                                    </div>
                                    <div className='px-2 pt-2 pt-xl-3 px-xl-3'>
                                        <div>
                                            <div className='f-14 text-black'>Registro de Sesión</div>
                                            <div className='f-12 text-gray'>Recomendaciones, Observaciónes</div>
                                        </div>
                                        <textarea rows={4} value={state?.sessionRecord} onChange={(evt) => {

                                            setState({ ...state, sessionRecord: evt.currentTarget.value, require_update: true })

                                        }} className='input--light py-1'></textarea>
                                    </div>

                                    <div className='px-3 pt-3 d-flex'>
                                        <div className='col'></div>
                                        <div className={`bv-pill cursor-pointer ${state.require_update === true ? 'bv-pill--green' : 'bv-pill--gray'}`} onClick={() => {
                                            update()

                                        }}>Guardar Cambios</div>
                                    </div>

                                    <div className='px-2 pt-2 pt-xl-3 px-xl-3'>
                                        <div>
                                            <div className='f-14 text-black'>Acuerdos</div>
                                            <div className='f-12 text-gray'></div>
                                        </div>

                                        <div className='d-flex align-items-center'>

                                            <input type={'text'} value={state.agreement} onChange={(evt) => {
                                                setState({ ...state, agreement: evt.currentTarget.value })
                                            }} className='input--light me-1'></input>
                                            {/* AGREGAR FAMILIAR  */}

                                            {/* <div className='cursor-pointer d-flex flex-column  align-items-center txt-center' onClick={() => {
                                                selectFamily();
                                            }}>
                                                <div className='ps-0 cur'> <AiOutlinePlusCircle size={26} color={'#30B7E7'}></AiOutlinePlusCircle></div>
                                                <div className='f-10 text-gray'>Agregar Familiar</div>
                                            </div> */}

                                            {/* AGREGAR FAMILIAR  */}
                                            <div className='bv-pill bv-pill--primary  cursor-pointer' onClick={() => {


                                                onAddAgreement();


                                            }}>

                                                <div className='px-0'>Agregar</div>
                                                <div className='col'></div>
                                                <div className='ps-0 cur'> <FiCornerRightDown size={16} /></div>
                                            </div>

                                        </div>

                                        <div>
                                            {state.cita?.agreements.map((agreement, i) => {
                                                return (
                                                    <div key={i} className='bv-tag'>
                                                        <div className='px-1 text-white'>{agreement.agreementTitle}</div>
                                                        <div className='ps-0 cursor-pointer' onClick={() => {
                                                            onRemoveAgreement({ agreement })

                                                        }}> <AiOutlineCloseCircle size={22} color={'white'} /></div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>

                                    <div className='px-2 pt-2 pt-xl-3 px-xl-3'>
                                        <div>
                                            <div className='f-14 text-black'>Etiquetas</div>
                                            <div className='f-12 text-gray'>Asignar Tags al Cliente </div>
                                        </div>

                                        <div className='d-flex align-items-center'>



                                            <div className='col me-1 position-relative'>

                                                <div className='bv-list-select hide-scroll' style={{ marginTop: '-' + ((onFilterTags().length * 44) >= 256 ? '264' : (onFilterTags().length * 44)).toString() + 'px' }}>

                                                    {
                                                        onFilterTags().map((tag, i) => {
                                                            return (
                                                                <div className='bv-list-select-item' key={i} onClick={() => {

                                                                    onAddTag({ tag })

                                                                }}>
                                                                    <div className='bv-icon'><AiOutlineTags color={primary} /></div>
                                                                    <div className='f-12 bold'>{tag.name}</div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>

                                                <input type={'text'} value={state.tag} onChange={(evt) => {
                                                    console.log(evt.currentTarget.value)
                                                    setState({ ...state, tag: evt.currentTarget.value })

                                                }} className='input--light'></input>


                                            </div>


                                            <div className='bv-pill bv-pill--primary  cursor-pointer' onClick={() => {

                                                onCreateTag()

                                            }}>

                                                <div className='px-0'>Agregar</div>
                                                <div className='col'></div>
                                                <div className='ps-0'> <FiCornerRightDown size={16} /></div>
                                            </div>
                                        </div>

                                        <div>
                                            {state.cita?.patient?.tag?.map((tag, i) => {
                                                return (
                                                    <div key={i} className='bv-tag'>
                                                        <div className='px-1 text-white'>{tag.name}</div>
                                                        <div className='ps-0 cursor-pointer' onClick={() => {
                                                            onRemoveTag({ tag })
                                                        }}> <AiOutlineCloseCircle size={22} color={'white'} /></div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>




                        </div>

                        <div className='col-12 col-xl-4 px-1 vh-xl-100-overflowed hide-scroll px-lg-3 px-xl-0 pe-xl-3'>
                            <Renderif isTrue={state.cita?.lastAppointment !== null}>
                                <div className='pt-3 px-2 px-xl-0'>
                                    <div className='d-flex align-items-center pb-1'>
                                        <div className='f-12 text-gray bold'>Última cita del cliente:</div>
                                        <div className='col'></div>
                                        {/* <div className={`bv-pill bv-pill--primary cursor-pointer`}>
                                    Ver todas las Anteriores
                                </div> */}
                                    </div>

                                    <div className='b-top b-bottom pt-3'>
                                        <div className='d-flex  align-items-center'>
                                            <div>
                                                <div className='text-gray f-12'>{state.cita?.patient.firstName} {state.cita?.patient.lastName}</div>
                                                <div className='text-gray f-10'>{state.cita?.patient.email}</div>
                                            </div>
                                            <div className='col'></div>
                                            <div className={`bv-pill bv-pill--green cursor-pointer`} onClick={() => {
                                                // navigate(-1);
                                                navigate('/administrador/citas', { replace: true })
                                            }}>
                                                Ver seguimiento
                                            </div>
                                        </div>

                                        <div className='d-flex mt-2'>
                                            <div className='col d-flex justify-content-start'>
                                                <div className='text-gray f-12'>#{state.cita?.patient.proceedings}</div>
                                            </div>
                                            <div className='col'></div>

                                            <div className='px-1'>
                                                <div className='text-gray f-12'>{state.cita?.lastAppointment?.date}</div>
                                            </div>

                                            <div className='px-1'>
                                                <div className='text-gray f-12'>Sesión : <span className='bold text-black'>{state.cita?.numberOfSession - 1}</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Renderif>



                            <div className='row m-0 mt-3'>

                                <div className='col-12 col-sm-6 col-md-4 col-xl-6  p-0 '>

                                    <div className='bg-light r-10 pb-2 h-100 me-1'>


                                        <div className='d-flex px-2 pt-2'>
                                            <div className='f-14 text-gray bold'>Tips</div>
                                            <div className='col'></div>

                                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                                setState({ ...state, show_add: 'agregar-tip' })
                                            }}>
                                                <AiOutlinePlusCircle size={26} color={'#0972CE'}></AiOutlinePlusCircle>
                                            </div>

                                        </div>

                                        <div className='px-2'>
                                            {state.cita?.tips.map((item, i) => {
                                                return (


                                                    <TipCard onDeleteTip={(tip) => {
                                                        onDeleteTip(tip)
                                                    }} tip={item} i={i} key={i}></TipCard>


                                                )
                                            })}
                                        </div>

                                    </div>

                                </div>



                                <div className='col-12 col-sm-6 col-md-8 col-xl-6  p-0 '>

                                    <div className='bg-light r-10 pb-2 h-100 ms-1'>

                                        <div className='d-flex px-2 pt-2'>
                                            <div className='f-14 text-gray bold'>Documentos</div>
                                            <div className='col'></div>

                                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                                setState({ ...state, show_add: 'agregar-doc' })
                                            }}>
                                                <AiOutlinePlusCircle size={26} color={'#0972CE'}></AiOutlinePlusCircle>
                                            </div>

                                        </div>

                                        <div className=' d-flex flex-column pt-2 '>

                                            {
                                                state.cita?.documents.map((doc, i) => {
                                                    console.log(doc)
                                                    return (
                                                        <div className={`p-2 d-flex align-items-center highlight-hover cursor-pointer ${i % 2 === 0 ? 'bg-white' : 'bg-white'}`} onClick={() => {
                                                            window.open(doc.documentUrl, '_blank')
                                                        }}>
                                                            <div className='bv-icon'><AiFillFile color='#CCC'></AiFillFile></div>
                                                            <div className='f-12 text-gray ps-2'>{doc.title}</div>
                                                            <div className='col'></div>
                                                            {/* <div className='bv-pill bv-pill--primary cursor-pointer'>Ver o Editar</div> */}
                                                        </div>
                                                    )
                                                })
                                            }









                                        </div>
                                    </div>


                                </div>

                            </div>



                        </div>


                    </div>

                </div>




            </div>
        </>
    )
}

const ClienteDetail = ({ description = '' }) => {

    const [state, setState] = useState({
        tab: 0
    })
    const arr = [1, 1, 1, 1, 1, 1, 1]
    return (




        <div className='w-100'>
            <div className='text-gray f-12'>

                {description}
            </div>
        </div>




    )
}
const ClienteItem = ({ ...props }) => {

    const [state, setState] = useState({
        show_detail: false
    })
    return (
        <div className='b-light r-5 align-items-start highlight-hover--light' onClick={() => {
            setState({ ...state, show_detail: !state.show_detail })
        }}>

            <div className='d-flex p-2'>

                <div>
                    <div className='text-gray f-12 bold'>Dr. Ray Marqueda Mejia</div>
                    <div className='text-gray f-10'>24 de Julio 2023, 5:30 PM</div>
                </div>

                <div className='col'></div>

                <div className='d-flex align-items-center'>
                    <div className='f-12 bold text-gray'> #AT318790 </div>
                    <div className='bv-icon bv-icon--mid'><MdKeyboardArrowRight color='gray' size={20}></MdKeyboardArrowRight></div>
                </div>

            </div>

            <div className='d-flex px-2 pt-2 pb-1'>
                <div className='d-flex justify-content-start'>
                    <div className='text-gray f-12'><span className="bold">Edad:</span> 32 </div>
                </div>
                <div className='d-flex justify-content-start ms-2'>
                    <div className='text-gray f-12'><span className='bold'>Sexo:</span>: M </div>
                </div>



                <div className='d-flex justify-content-end ps-2'>
                    <div className='text-gray f-12'><span className='bold'>Sesión: </span>5</div>
                </div>
            </div>

            <Renderif isTrue={state.show_detail}>
                <div className='mt-2 bg-light p-2 b-top'>
                    <ClienteDetail description={"sad"}></ClienteDetail>
                </div>
            </Renderif>


        </div>
    )
}
